import React, { Component } from 'react';
import { Button, Grid, Paper, TableCell, Table, TableHead, TableRow, TableBody } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import i18n from '../i18n';


import '../assets/stylesheets/Setting.css';

class AgentsDetailsModal extends Component {

  // This is a function to dynamically build table body.
  buildTable = (agents) => {
    return (
      <div>
        <span>{i18n.t('agents:agentDetails')}</span>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{i18n.t('agents:firstName')}</TableCell>
              <TableCell>{i18n.t('agents:lastName')}</TableCell>
              <TableCell>
                {i18n.t('agents:email')}
              </TableCell>
              <TableCell>
                {i18n.t('agents:phoneNumber')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {agents && agents.map(agent => (
              <TableRow key={agent.firstName + agent.lastName + agent.email + agent.phoneNumber.Home}>
                <TableCell>{agent.firstName}</TableCell>
                <TableCell>{agent.lastName}</TableCell>
                <TableCell>{agent.email}</TableCell>
                <TableCell>{agent.phoneNumber.Home}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  };
 
  render() {
    const { showModal, onClose, agents } = this.props;

    return (
      <Modal open={showModal} onClose={onClose}>
        <Paper className="editModal">
          <div>
            {agents.length > 0 ? (
              this.buildTable(agents)  
              ) : (
                <div>
                  <h3>{i18n.t('agents:noAgents')}</h3>
                </div>
              )}
            <Grid container>
              <Grid item xs={12}>
                <Button
                  onClick={onClose}
                  className="ssenseButton ssenseDefault"
                >
                  {i18n.t('close')}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Modal>
    )
  }
}

AgentsDetailsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  agents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.object,
    }).isRequired,
  ).isRequired,
};

export default AgentsDetailsModal;
